import { Route, Switch } from "react-router-dom";
import { authService } from "../../service/authService";
import { useEffect, useState } from "react";
import SideBar from "../SideBar/SideBar";
import UsersPage from "../CRUDPages/UsersPage/UsersPage";
import MaklersPage from "../CRUDPages/MaklersPage/MaklersPage";
import PartnersPage from "../CRUDPages/PartnersPage/PartnersPage";
import MaklersEditPage from "../CRUDPages/MaklersPage/MaklersEditPage";
import MaklersAddPage from "../CRUDPages/MaklersPage/MaklersAddPage";
import PartnersAddPage from "../CRUDPages/PartnersPage/PartnersAddPage";
import PartnersEditPage from "../CRUDPages/PartnersPage/PartnersEditPage";
import StatisticsPage from "../ReadOnlyPages/StatisticsPage";
import RankingPage from "../ReadOnlyPages/RankingPage";
import UserMessagesPage from "../CRUDPages/UsersPage/UserMessagesPage";
import UserPropertyPage from "../CRUDPages/UsersPage/UserPropertyPage";
import OffertsPage from "../OffertsPage/OffertsPage";
import CoworkersPage from "../CRUDPages/CoworkersPage/CoworkersPage";
import CoworkersDetails from "../CRUDPages/CoworkersPage/CoworkersDetails";
import CoworkersEditPage from "../CRUDPages/CoworkersPage/CoworkersEditPage";
import UsersDetails from "../CRUDPages/UsersPage/UsersDetails";
import MaklersDetails from "../CRUDPages/MaklersPage/MaklersDetails";
import PartnersDetails from "../CRUDPages/PartnersPage/PartnersDetails";
import CoworkerAddPage from "../CRUDPages/CoworkersPage/CoworkerAddPage";
import "./HomePage.css";
import UserNotesPage from "../NotesPage/UserNotesPage";
import MaklerPropertiesPage from "../CRUDPages/MaklersPage/MaklerPropertyPage";
import UserPunktePage from "../CRUDPages/UsersPage/UserPunktePage/UserPunktePage";

function HomePage() {
  const [canNotifications, setCanNotifications] = useState(false);
  const [canCoworkers, setCanCoworkers] = useState(false);
  const [canStatistics, setCanStatistics] = useState(false);
  const [canRanking, setCanRanking] = useState(false);
  const [canPartners, setCanPartners] = useState(false);
  const [canBrokers, setCanBrokers] = useState(false);
  const [canCustomers, setCanCustomers] = useState(false);
  const [canMessages, setCanMessages] = useState(false);

  useEffect(() => {
    authService.getCurrentUser().then((res) => {
      setCanBrokers(isAllowed("canBrokers", res.data));
      setCanCoworkers(isAllowed("canCoworkers", res.data));
      setCanStatistics(isAllowed("canStatistics", res.data));
      setCanRanking(isAllowed("canRanking", res.data));
      setCanPartners(isAllowed("canPartners", res.data));
      setCanCustomers(isAllowed("canCustomers", res.data));
      setCanNotifications(isAllowed("canNotifications", res.data));
      setCanMessages(isAllowed("canMessages", res.data))
    });
  }, []);

  const isAllowed = (permission, user) => {
    return user.isAdmin || user[permission];
  };

  return (
    <div className="bg-gray-200 h-screen w-full px-0 mx-0 flex">
      <SideBar />
      <div className="bg-gray-200 margin-left w-full relative w-90per">
        <Switch>
          {canCustomers && (
            <Route exact path="/customers/:id" component={UsersDetails} />
          )}
          {canCustomers && <Route exact path="/customers" component={UsersPage} />}
          {(canCustomers && canMessages) && (
            <Route
              exact
              path="/customers/:id/messages"
              component={UserMessagesPage}
            />
          )}
          {canCustomers && (
            <Route
              exact
              path="/customers/:id/property"
              component={UserPropertyPage}
            />
          )}
          {canCustomers && (
            <Route
              exact
              path="/customers/:id/notes"
              component={UserNotesPage}
            />
          )}
          {canBrokers && (
            <Route exact path="/brokers/add" component={MaklersAddPage} />
          )}
          {canBrokers && (
            <Route exact path="/brokers/:id/edit" component={MaklersEditPage} />
          )}
          {canBrokers && (
            <Route exact path="/brokers/:id" component={MaklersDetails} />
          )}
          {canBrokers && (
            <Route exact path="/brokers/:id/punkte" component={UserPunktePage} />
          )}
          {canBrokers && (
            <Route exact path="/brokers" component={MaklersPage} />
          )}
          {canBrokers && (
            <Route
              exact
              path="/brokers/:id/properties"
              component={MaklerPropertiesPage}
            />
          )}
          {canCoworkers && (
            <Route exact path="/coworkers/add" component={CoworkerAddPage} />
          )}
          {canCoworkers && (
            <Route
              exact
              path="/coworkers/:id/edit"
              component={CoworkersEditPage}
            />
          )}

          {canCoworkers && (
            <Route exact path="/coworkers/:id" component={CoworkersDetails} />
          )}
          {canCoworkers && (
            <Route exact path="/coworkers" component={CoworkersPage} />
          )}

          {canPartners && (
            <Route exact path="/partners/add" component={PartnersAddPage} />
          )}
          {canPartners && (
            <Route
              exact
              path="/partners/:id/edit"
              component={PartnersEditPage}
            />
          )}
          {canPartners && (
            <Route exact path="/partners/:id" component={PartnersDetails} />
          )}
          {canPartners && (
            <Route exact path="/partners" component={PartnersPage} />
          )}

          {canRanking && (
            <Route exact path="/ranking" component={RankingPage} />
          )}

          {canStatistics && (
            <Route exact path="/statistics" component={StatisticsPage} />
          )}

          {canNotifications && (
            <Route exact path="/offerts" component={OffertsPage} />
          )}

          {canCustomers && <Route exact path="/" component={UsersPage} />}
        </Switch>
      </div>
    </div>
  );
}

export default HomePage;
